import cx from 'classnames';
import { PropsWithChildren } from 'react';
import styles from './Footer.module.scss';
import { CatFooter } from 'blocks-nextjs/blocks-react/components/Footer';

export const FooterContainer = ({
  children,
  isCheckout = false,
  withSalesforceChat = false,
  footerDesignUpdate = false
}: PropsWithChildren<{
  isCheckout?: boolean;
  withSalesforceChat?: boolean;
  footerDesignUpdate?: boolean;
}>) => (
  <CatFooter
    className={cx('w-100 d-print-none d-block', styles['footer'], {
      [styles['footer-mobile-padding-remove']]: footerDesignUpdate,
      [styles['footer-checkout']]: isCheckout,
      [styles['footer-salesforce-chat']]: withSalesforceChat
    })}
  >
    {children}
  </CatFooter>
);
